import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { AddClockCardModelComponent } from '../add-clock-card-model/add-clock-card-model.component';
import { TimeClockService } from 'src/app/services/time-clock/time-clock.service';
import { CommonService } from 'src/app/services/common/common.service';
import { Filter } from 'src/app/pages/filter/filter.model';
import { PaginationInstance } from 'ngx-pagination';
import { GlobalService } from 'src/app/services/global/global.service';
import { DeleteItemComponent } from 'src/app/pages/delete-item/delete-item.component';
import { AddClockCardComponent } from '../add-clock-card/add-clock-card.component';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { AppService } from 'src/app/services/app/app.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-main-clock-card-lobby',
  templateUrl: './main-clock-card-lobby.component.html',
  styleUrls: ['./main-clock-card-lobby.component.scss']
})
export class MainClockCardLobbyComponent {
  public currentTab: string = "active";
  public userDetails: any[] = [];
  public filterElem: any;
  private animationConfig: {} = { enterAnimationDuration: '300ms', exitAnimationDuration: "300ms" }
  public searchInput: string = '';
  private previousInputValue: string = '';
  public pageSizeOptions = GlobalService.pageSizeOptions;
  public maxPaginationSize = GlobalService.maxPaginationSize
  public filterObj: Filter = {
    operand: "and",
    arr: []
  }
  public filterArr: any[] = [
    { key_name: "Name", key_val: "name", type: 'text' },
    { key_name: "Created at", key_val: "c_at", type: 'date' },
  ]
  public config: PaginationInstance = {
    itemsPerPage: this.pageSizeOptions[0],
    currentPage: 0,
  };
  public isAdmin:boolean=false
  public isFilterShow: boolean = false;
  public cardArr: any[] = []
  constructor(private dialog: MatDialog, private timeClockService: TimeClockService, private commonService: CommonService, private router: Router,
     private datePipe:DatePipe,private cookieService:CookieService,private appService:AppService, private spinner: NgxSpinnerService,) { }
  ngOnInit() {
    if (this.cookieService.get('user_id') && window.location.href.includes('iframe')) {            
      this.appService.storeData('training-portal.admin-authToken', this.cookieService.get('user_id'));
      this.appService.storeSessionData('isAdmin', JSON.stringify(true));
      this.isAdmin = true;
    }
    else {
      this.isAdmin = false;
    }
    this.commonService.setTitle("Time Clock lobby")
    this.userDetails = [
      {
        name: "abc",
        age: 12,
        category: "A"
      },
      {
        name: "abc",
        age: 12,
        category: "A"
      }
    ]
    this.userDetails.forEach(fruit => {
      for (let key in fruit) {
        if (fruit.hasOwnProperty(key)) {
        }
      }
    });
    this.createNewObj();
    this.getList();
  }
  createNewObj() {
    let newArr = [
      { key: "name", val: [{ label: "abc" }, { label: "def" }] }
    ]
  }
  onTabChange(value) {
    this.currentTab = value;
  }
  onAddClockCard(item) {
    const dialogRef = this.dialog.open(AddClockCardModelComponent, Object.assign({
      data: item,
      minWidth: "230px", width: "40%"
      // width: '80%', height: '95%', maxWidth: '100vw', 
    }));
    dialogRef.afterClosed().subscribe(result => {
      if (result && (result["content_edited"] == true)) {
        this.getList();
      }
    });
  }

  
  onSearch(event: any) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue == '' && this.previousInputValue !== '') {
      this.config.currentPage = 0;
      this.getList();
    }
  }
  onGo() {
    if (this.searchInput.trim() != '') {
      this.config.currentPage = 0;
      this.getList();
    }
  }
  callApi(obj) {
    this.filterObj = obj;
    this.getList();
  }
  onFilterView() {
    this.isFilterShow = !this.isFilterShow;
    if (!this.isFilterShow && this.filterObj.arr.length > 0) {
      this.filterObj.arr = [];
      this.getList();
    }
  }
  getList() {
    let obj = {
      sh: this.searchInput.trim(),
      f_a: this.filterObj.arr,
      op_nd: this.filterObj.operand
    }
    this.cardArr = [];
    this.previousInputValue = this.searchInput;
    this.spinner.show()
    this.timeClockService.getTimeClockList(obj).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        //   this.isSpinnerLoading = false
        if (success.status == 200) {
        
          this.cardArr = success.msg;
        }
      },
      error: (error: any) => {
        //this.isSpinnerLoading = false
        this.commonService.handleError(error);
      }
    })
  }
  onDeleteItem(item) {
    const dialogRef = this.dialog.open(DeleteItemComponent, Object.assign({
      data: { api_type: "delete_content", content_type: "delete_clock_card", id: item.id }
    }, this.animationConfig));
    dialogRef.afterClosed().subscribe(result => {
      if (result && (result["delete_content"] == true)) {
        this.getList();
      }
    });
  }
  onAssign(item) {
    const dialogRef = this.dialog.open(AddClockCardComponent, Object.assign({
      width: '80%', height: '95%', maxWidth: '100vw', data: item,
    }));
    dialogRef.afterClosed().subscribe((result) => {
      this.getList();
    })
  }
  onAccessClock(item) {

    // this.router.navigate(['/rec/time-clock/dashboard/'])
    if(this.isAdmin){
      this.router.navigate(['/iframe/time-clock-dashboard/'], { queryParams: item });
    }
    else{
      this.router.navigate(['/rec/time-clock/dashboard/'], { queryParams: item });
    }
   
  }
 
}
